export default {
    install(Vue) {
        Vue.prototype.$setLanguage = function(language) {
            this.$root.$i18n.locale = language;
        };
    },
};
